import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { formatPrice } from '../../../utils/helpers';

const STATUS = {
  pending_payment: ['Pago pendiente', 'bg-amber-500/10 text-amber-300 ring-amber-500/20'],
  paid: ['Pagado', 'bg-sky-500/10 text-sky-300 ring-sky-500/20'],
  accepted_by_seller: ['Aceptado', 'bg-sky-500/10 text-sky-300 ring-sky-500/20'],
  searching_driver: ['Buscando repartidor', 'bg-violet-500/10 text-violet-300 ring-violet-500/20'],
  shipped: ['Enviado', 'bg-indigo-500/10 text-indigo-300 ring-indigo-500/20'],
  delivered: ['Entregado', 'bg-emerald-500/10 text-emerald-300 ring-emerald-500/20'],
  delivered_local: ['Entregado', 'bg-emerald-500/10 text-emerald-300 ring-emerald-500/20'],
  delivered_national: ['Entregado', 'bg-emerald-500/10 text-emerald-300 ring-emerald-500/20'],
  cancelled: ['Cancelado', 'bg-rose-500/10 text-rose-300 ring-rose-500/20'],
};

const StatusPill = ({ status }) => {
  const [label, cls] = STATUS[status] || [status?.replace(/_/g, ' ') || '—', 'bg-white/5 text-gray-300 ring-white/10'];
  return <span className={`text-[11px] font-medium px-2.5 py-1 rounded-full ring-1 capitalize ${cls}`}>{label}</span>;
};

export const RecentOrdersTable = ({ orders }) => (
  <div className="rounded-2xl border border-white/[0.06] bg-gray-900 shadow-[0_8px_30px_rgba(0,0,0,0.35)] overflow-hidden" data-testid="recent-orders">
    <div className="flex items-center justify-between px-6 py-4 border-b border-white/[0.06]">
      <div>
        <p className="text-[11px] uppercase tracking-[0.14em] text-gray-400 font-semibold">Control de daños</p>
        <p className="text-white font-semibold">Últimos 5 pedidos</p>
      </div>
      <Link to="/admin/orders" className="text-xs text-orange-400 hover:text-orange-300 inline-flex items-center gap-1" data-testid="recent-orders-all-link">
        Ver todos <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[11px] uppercase tracking-wider text-gray-500">
            <th className="text-left font-medium px-6 py-3">ID</th>
            <th className="text-left font-medium px-6 py-3">Cliente</th>
            <th className="text-right font-medium px-6 py-3">Monto</th>
            <th className="text-left font-medium px-6 py-3">Estatus</th>
            <th className="px-6 py-3" />
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <tr><td colSpan={5} className="px-6 py-10 text-center text-gray-500">Aún no hay pedidos</td></tr>
          ) : orders.map((o, i) => (
            <tr key={o.order_id} className="border-t border-white/[0.04] hover:bg-white/[0.02] transition-colors" data-testid={`recent-order-row-${i}`}>
              <td className="px-6 py-3 font-mono text-xs text-gray-300">#{o.order_id?.slice(0, 8).toUpperCase()}</td>
              <td className="px-6 py-3">
                <p className="text-gray-100">{o.buyer_name || '—'}</p>
                <p className="text-xs text-gray-500">{o.created_at ? new Date(o.created_at).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' }) : ''}</p>
              </td>
              <td className="px-6 py-3 text-right font-semibold text-white tabular-nums">{formatPrice(o.total || 0)}</td>
              <td className="px-6 py-3"><StatusPill status={o.status} /></td>
              <td className="px-6 py-3 text-right">
                <Link to={`/admin/orders/${o.order_id}`} data-testid={`recent-order-detail-${i}`}
                  className="inline-flex items-center gap-1 text-xs font-semibold text-gray-200 bg-white/5 hover:bg-orange-500 hover:text-white ring-1 ring-white/10 rounded-full px-3 py-1.5 transition-colors">
                  Ver Detalles <ArrowRight className="w-3 h-3" />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
